import React from "react";
import Tab from "./Components/Tab";
import { MdOutlineAttachMoney } from "react-icons/md";

const BuySell = () => {
  return (
    <div className="p-8">
      <div >
        <div className="  w-auto shadow-md text-center p-6 rounded-sm flex py-8  border  ">
          <MdOutlineAttachMoney size={90} />
          <div>
            <p className=" text-slate-400 pt-1 lg:text-2xl tracking-wider   ">
              
              Your Dio Balance
            </p>
            <h1 className=" text-3xl lg:text-5xl  tracking-wider">787,150</h1>
          </div>
        </div>
      </div>
      <div className=" pt-8">
      <Tab />
      </div>
    </div>
  );
};

export default BuySell;
